// src/stores/portfolioSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    hasPortfolio: false,
    selectedPortfolioId: null,
    portfolioData: [], // Portföy listesi eklendi
};

const portfolioSlice = createSlice({
    name: 'portfolio',
    initialState,
    reducers: {
        addPortfolio: (state, action) => {
            state.hasPortfolio = true;
            state.portfolioData.push(action.payload); // Yeni portföyü listeye ekleyin
        },
        removePortfolio: (state) => {
            state.hasPortfolio = false;
            state.selectedPortfolioId = null;
            state.portfolioData = []; // Tüm portföyleri temizleyin
        },
        setSelectedPortfolio: (state, action) => {
            state.selectedPortfolioId = action.payload;
        },
        renamePortfolio: (state, action) => {
            const { id, name } = action.payload;
            const portfolio = state.portfolioData.find((p) => p.id === id);
            if (portfolio) {
                portfolio.name = name; // İlgili portföyün adını güncelleyin
            }
        },
        setPortfolioData: (state, action) => {
            state.portfolioData = action.payload; // Tüm portföyleri güncelleyin
            state.hasPortfolio = action.payload.length > 0; // Portföy var mı kontrolü
        },
    },
});

export const { addPortfolio, removePortfolio, setSelectedPortfolio, renamePortfolio, setPortfolioData } = portfolioSlice.actions;

export default portfolioSlice.reducer;
